import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-end" }
const _hoisted_2 = {
  key: 0,
  class: "mt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_google_sign_in = _resolveComponent("ontos-google-sign-in")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ontos_auth_layout = _resolveComponent("ontos-auth-layout")!
  const _component_ontos_base = _resolveComponent("ontos-base")!

  return (_openBlock(), _createBlock(_component_ontos_base, _mergeProps(_ctx.baseProps, {
    flush: "",
    ref: "base"
  }), {
    default: _withCtx(() => [
      _createVNode(_component_ontos_auth_layout, {
        title: _ctx.$tt('login-title')
      }, {
        social: _withCtx(() => [
          _createVNode(_component_ontos_google_sign_in, {
            onSigned: _cache[0] || (_cache[0] = ($event: any) => (_ctx.enter())),
            onFailed: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onGoogleFailed($event)))
          })
        ]),
        foot: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.$tt('no-account-message')), 1),
          _createVNode(_component_router_link, {
            class: "plain-link ms-1",
            to: {name: 'signup'}
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$tt('request-invitation')), 1)
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_form, {
            onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.login()), ["prevent"]))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.email,
                "onUpdate:modelValue": [
                  _cache[2] || (_cache[2] = ($event: any) => ((_ctx.email) = $event)),
                  _cache[3] || (_cache[3] = ($event: any) => (_ctx.errorMessages.email = ''))
                ],
                label: _ctx.$tt('email'),
                type: "email",
                autocomplete: "email",
                "error-messages": _ctx.errorMessages.email
              }, null, 8, ["modelValue", "label", "error-messages"]),
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.password,
                "onUpdate:modelValue": [
                  _cache[4] || (_cache[4] = ($event: any) => ((_ctx.password) = $event)),
                  _cache[5] || (_cache[5] = ($event: any) => (_ctx.errorMessages.password = ''))
                ],
                label: _ctx.$tt('password'),
                type: "password",
                autocomplete: "current-password",
                class: "mt-2",
                "error-messages": _ctx.errorMessages.password
              }, null, 8, ["modelValue", "label", "error-messages"]),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  size: "small",
                  class: "auth-link",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.resetPassword()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$tt('auth.forgot-password')), 1)
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_v_btn, {
                type: "submit",
                block: "",
                color: "primary",
                size: "large",
                class: "mt-4",
                loading: _ctx.isSaving
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$tt('login')), 1)
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          }),
          (_ctx.unverified)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  size: "small",
                  class: "auth-link",
                  loading: _ctx.isSaving,
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.resendVerification()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$tt('auth.resend-verification')), 1)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["title"])
    ]),
    _: 1
  }, 16))
}